import styled from 'styled-components';

export const Container = styled.div`
  max-width: 376px;
  border-radius: 4px;
  background-color: #fff;
  margin: 25px 0;
  padding: 25px;
  box-shadow: 0 0 1px #eaeaea inset;

  .team-header {
    font-size: 16px;
    color: #2c2c2c;
  }

  .member-avatar {
    background-color: #8e8e8e;
    width: 48px;
    height: 48px;
    margin-right: 17px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .flex-names {
    margin-top: 12px;
  }

  .member-name {
    font-size: 16px;
    color: #2c2c2c;
  }

  .member-role {
    font-size: 14px;
    color: #8e8e8e;
    font-weight: 300;
  }
`;

export const FlexNames = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
